const module = { name: 'video/iframe', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



const Styles = {
    IFRAME: 'fandangoJWEmbed',
}


const Selectors = {
    IFRAME: 'fandangoVideoPlayerFrame',
    PLAYER_WRAP: '#vdlpVideoPlayerWrap'
}


const RegExes = {
    AUTO_PLAY: /([&?]autoplay=)(true|false)/ig,
}
function setAutoPlay(url, autoplay) {
    if (RegExes.AUTO_PLAY.test(url)) {
        return url.replace(RegExes.AUTO_PLAY, '$1' + autoplay);
    }
    return url + (url.indexOf('?') < 0 ? '?' : '&') + ('autoplay=' + autoplay);
}
function replaceIframe(playerSrc, opts) {
    if (!playerSrc) {
        debugLog.info(module.name, 'replaceIframe missing required param "playerSrc"');
        return false;
    }
    opts = opts || {};
    const $player = $(opts.playerWrapSelector || Selectors.PLAYER_WRAP);
    let $iframe = $('.' + Styles.IFRAME, $player);
    if ($iframe.length) {
        $iframe.remove();
    }
    if (typeof opts.autoplay === 'boolean') {
        playerSrc = setAutoPlay(playerSrc, opts.autoplay);
    }
    const params = {
        name: Styles.IFRAME,
        class: Styles.IFRAME,
        id: Selectors.IFRAME,
        src: playerSrc,
        scrolling: 'no',
        allowFullScreen: '',
        allow: 'autoplay; fullscreen',
        frameborder: 0,
        marginwidth: 0,
        marginheight: 0
    };
    if (opts.width) {
        params.width = opts.width;
    }
    if (opts.height) {
        params.height = opts.height;
    }
    $iframe = $('<iframe />', params);
    $player.html($iframe);
    return true;
}
module.exports = {
    load: replaceIframe
};
export default module.exports;